import React from "react";
import { IconButton } from "@chakra-ui/react";
import { FiShare2 } from "react-icons/fi";

const ShareLinkButton = ({ onClick, ...props }) => {
  return (
    <IconButton
      icon={<FiShare2 size={20} />}
      size="sm"
      variant="outline"
      bg="white"
      borderColor="rgba(208, 204, 213, 0.3)"
      borderWidth="1px"
      borderRadius="100px"
      p={3}
      color="#0C001C"
      aria-label="Share meeting link"
      onClick={onClick}
      w="44px"
      h="44px"
      _hover={{
        bg: "white",
        borderColor: "rgba(208, 204, 213, 0.5)",
      }}
      _active={{
        bg: "white",
        borderColor: "rgba(208, 204, 213, 0.7)",
      }}
      data-testid="share-link-button"
      {...props}
    />
  );
};

export default ShareLinkButton;
